import React from "react";
import ReactDOM from "react-dom/client";
import { IntercomProvider } from "react-use-intercom";
import { FirebaseAppProvider } from "reactfire";
import App from "./App";
import firebaseConfig from "./services/firebase/firebase";
import { initializeCustomerIO } from "./services/customerio";
import { INTERCOM_APP_ID } from "./services/intercom";
import { initializePostHog } from "./services/posthog";
import { buildCustomerIOEventContext } from "./tracking/customer-io-event-context";
import { captureSentryException, initSentry } from "./services/sentry";
import "./styles/index.css";

initSentry();
initializePostHog();
initializeCustomerIO({ getEventContext: buildCustomerIOEventContext });

// Global error handlers for errors that Error Boundaries can't catch
window.addEventListener("error", (event) => {
  console.error("Global error:", event.error);
  captureSentryException(event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
  captureSentryException(event.reason);
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <IntercomProvider appId={INTERCOM_APP_ID} autoBoot initializeDelay={500}>
      <FirebaseAppProvider firebaseConfig={firebaseConfig}>
        <App />
      </FirebaseAppProvider>
    </IntercomProvider>
  </React.StrictMode>,
);
